$(function () {

    // SVG Definitions polyfill
    svg4everybody();

    Homepage.init();
    Menu.init();
    Project.init();
    Backstage.init();

    Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container) {
        // analytics handled by autotrack (google)

        // update body class
        $('body').removeClass (function (index, className) {
            return (className.match (/(^|\s)ns-\S+/g) || []).join(' ');
        }).addClass('ns-'+$(container).data('namespace'));

        $('body').removeClass (function (index, className) {
            return (className.match (/(^|\s)pt-\S+/g) || []).join(' ');
        }).addClass('pt-'+$(container).data('posttype'));

        // update page title
        $('.header__title').text($(container).data('title'));
    });

    Barba.Pjax.start();
});